import { render, staticRenderFns } from "./main-header.vue?vue&type=template&id=179971da"
import script from "./main-header.vue?vue&type=script&lang=js"
export * from "./main-header.vue?vue&type=script&lang=js"
import style0 from "./main-header.vue?vue&type=style&index=0&id=179971da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainLogo: require('/opt/iaravia.ru/src/components/main-logo.vue').default,MainContacts: require('/opt/iaravia.ru/src/components/main-contacts.vue').default,RzDottedLoader: require('/opt/iaravia.ru/node_modules/@razlet/ui/src/components/dotted-loader/index.vue').default,RzContainer: require('/opt/iaravia.ru/node_modules/@razlet/ui/src/components/container/index.vue').default,RzTransitionExpand: require('/opt/iaravia.ru/node_modules/@razlet/ui/src/components/transition-expand/index.vue').default})
